export const API_ROOT = '/rirekisho/api/';
const CSRF_TOKEN = document.getElementsByName('csrfmiddlewaretoken')[0].value;
export class BaseSyncUtil {
    syncState = 'ready';
    stateChangeListeners = [];
    setState(state) {
        this.syncState = state;
        this.stateChangeListeners.forEach((listener) => listener(state));
    }
    async apiRequest(path, method, data) {
        const res = await fetch(path, {
            method,
            credentials: 'include',
            headers: {
                'X-CSRFToken': CSRF_TOKEN,
                'Content-Type': 'application/json'
            },
            body: method !== 'GET' && data ? JSON.stringify(data) : undefined
        });
        if (res.ok) {
            return (await res.json());
        }
        else {
            let text = '';
            try {
                text = await res.text();
            }
            catch (e) {
                // pass
            }
            throw new Error(`API request error: ${res.status} response: ${text}`);
        }
    }
    getState() {
        return this.syncState;
    }
    listen(listener) {
        this.stateChangeListeners.push(listener);
    }
    removeListener(listener) {
        this.stateChangeListeners = this.stateChangeListeners.filter((l) => l !== listener);
    }
}
